/**
 * Playable heroes (KayKit Adventurers). Each has a model, a class glyph/color
 * for the select screen, lore, and a class id that maps to a starting kit in
 * ItemFactory.starterKit(). Game.begin(id) picks one before the run starts.
 */
export const CHARACTERS = [
  {
    id: "knight", model: "characters/knight", glyph: "⚔️", color: "#8fb8ff",
    name: "Sir Aldric Thorne", title: "The Ironclad",
    lore: "A royal guardsman stripped of his title after failing to hold the gate the night Relikara first breached. He descends to reclaim his honor — or be buried with it.",
    gear: "Knight's Longsword · Steel Plate · Round Shield",
  },
  {
    id: "barbarian", model: "characters/barbarian", glyph: "🪓", color: "#e0a15a",
    name: "Grommash Skullrender", title: "The Unbroken",
    lore: "His mountain clan was swallowed whole when Relikara's roots split the peaks. He fights not for treasure, but to tear the whole cursed place apart with his bare hands.",
    gear: "Savage Greataxe · Hide Harness",
  },
  {
    id: "rogue", model: "characters/rogue", glyph: "🗡️", color: "#7bd645",
    name: "Sable Vayne", title: "The Shadow",
    lore: "A guild thief who slipped past Relikara's wards chasing the score of a lifetime. She never found the way out — so now she just goes deeper, and richer.",
    gear: "Twin Daggers · Leather Garb · Smoke Bombs",
  },
  {
    id: "ranger", model: "characters/ranger", glyph: "🏹", color: "#9bd66a",
    name: "Kaelen Wildeye", title: "The Farstrider",
    lore: "A wilderness scout who alone can read Relikara's shifting corridors. He hunts its horrors from a distance, loosing arrows before they ever catch his scent.",
    gear: "Longbow · Ranger's Leathers · Quiver",
  },
  {
    id: "mage", model: "characters/mage", glyph: "🔮", color: "#c77dff",
    name: "Elara Moonwhisper", title: "The Exile",
    lore: "An arcanist banished for studying forbidden geometries. The Vault's impossible architecture is the greatest text she has ever read — and she means to master it.",
    gear: "Apprentice Staff · Mage Robes · Spellbook",
  },
];

export const DEFAULT_CHARACTER = "knight";
export const getCharacter = (id) => CHARACTERS.find((c) => c.id === id) || CHARACTERS[0];
